if (!("anchorName" in document.documentElement.style)) {
  const body = document.querySelector('body');
  const mutationObserver = new MutationObserver(prepareNoAnchorSupport);
  mutationObserver.observe(body, {childList: true, subtree: true, attributes: false});
  const resizeObserver = new ResizeObserver(prepareNoAnchorSupport);
  resizeObserver.observe(body);
  document.querySelector('html').classList.add('legacy-support-no-anchor');

  const intersectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      prepareNoAnchorSupportElement(entry.target);
    });
  }, {});

  document.querySelectorAll('[popovertarget]').forEach((popoverSwitch) => {
    intersectionObserver.observe(popoverSwitch);
  });


  let ticking = false;

  window.addEventListener("scroll", function (e) {

    if (!ticking) {
      window.requestAnimationFrame(function () {
        prepareNoAnchorSupport();
        ticking = false;
      });
    }

    ticking = true;
  });


  function prepareNoAnchorSupport() {
    document.querySelectorAll('[popovertarget]').forEach((popoverSwitch) => {
      prepareNoAnchorSupportElement(popoverSwitch);

    let oldPosition = JSON.stringify(popoverSwitch.getBoundingClientRect());

    setInterval(() => {
      const newPosition = JSON.stringify(popoverSwitch.getBoundingClientRect());
      if (oldPosition !== newPosition) {
        oldPosition = newPosition;
        prepareNoAnchorSupportElement(popoverSwitch);
      }
    }, 100);
    });
  }

  function prepareNoAnchorSupportElement(popoverSwitch) {
    try {
      const referenceElement = popoverSwitch.closest(`[style*="anchor-name"]:not([popover])`);
      if (referenceElement) {
        const { top, left, right, bottom } = referenceElement.getBoundingClientRect();
        const { clientWidth, clientHeight } = document.body;

        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-top-from-page-top', `${top +  + document.documentElement.scrollTop}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-top-from-page-bottom', `${clientHeight - top +  + document.documentElement.scrollTop}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-bottom-from-page-top', `${bottom +  + document.documentElement.scrollTop}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-bottom-from-page-bottom', `${clientHeight - bottom +  + document.documentElement.scrollTop}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-left-from-page-left', `${left}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-left-from-page-right', `${clientWidth - left}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-right-from-page-left', `${right}px`);
        popoverSwitch.popoverTargetElement.style.setProperty('--no-anchor-support-right-from-page-right', `${clientWidth - right}px`);
      }
    } catch (error) {
      console.error({error, popoverSwitch});
    }


  }

  prepareNoAnchorSupport();
}
